const OODForm7GeneralService = (() => {

    //Inputs
    let serviceDateInput;
    let startTimeInput;
    let endTimeInput;
    let ETADropdown;
    let contactMethodDropdown;
    let CNRDropdown;
    let bilingualSupplementDropdown;
    let narrativeOutcomeInput;

    // buttons
    let saveNoteBtn;
    let saveAndNewNoteBtn;
    let cancelNoteBtn;
    let updateNoteBtn;
    let deleteNoteBtn;

    // Case Note Edit Data
    let consumerId;
    let caseNoteId;
    let serviceDate;
    let startTime;
    let endTime;
    let ETA;
    let contactType;
    let bilingualSupplement;
    let notes;
    let CNR;

    //Case Note Data
    let caseManagerId;
    let userId;
    let serviceId;
    let referenceNumber;
    let formReadOnly = false;
    let currentEntryUserId;

    async function init(caseNoteData, currentConsumer, selectedConsumerServiceId, selectedConsumerReferenceNumber, currentRecordUserId, selectedServiceDate, clickSource = 'OODGrid') {
        DOM.clearActionCenter();
        document.querySelectorAll('.consumerListBtn').forEach(e => e.remove());

        consumerId = currentConsumer.id;
        currentEntryUserId = currentRecordUserId;

        if (caseNoteData && Object.keys(caseNoteData).length !== 0) {
            userId = $.session.UserId;
            caseNoteId = caseNoteData[0].caseNoteId;
            serviceDate = caseNoteData[0].serviceDate;
            startTime = caseNoteData[0].startTime;
            endTime = caseNoteData[0].endTime;
            ETA = caseNoteData[0].ETA;
            contactType = caseNoteData[0].contactType;
            bilingualSupplement = caseNoteData[0].bilingualSupplement;
            notes = caseNoteData[0].notes;
            CNR = caseNoteData[0].CNR;

        } else {
            caseManagerId = $.session.PeopleId;
            userId = $.session.UserId;
            serviceId = selectedConsumerServiceId;
            referenceNumber = selectedConsumerReferenceNumber;
            caseNoteId = '0';
            serviceDate = selectedServiceDate;
            startTime = '';
            endTime = '';
            ETA = '';
            contactType = '';
            bilingualSupplement = '';
            notes = '';
            CNR = '';
        }

        if (clickSource === 'OODGrid' && !$.session.OODUpdate) {
            formReadOnly = true;
        }

        if (clickSource === 'newEntry' && !$.session.OODInsert) {
            formReadOnly = true;
        }

        if ((userId !== currentRecordUserId)) {
            formReadOnly = true;
        }

        serviceDateInput = input.build({
            type: 'date',
            label: 'Service Date',
            style: 'secondary',
            value: UTIL.formatDateToIso(serviceDate.split(' ')[0]),
            readonly: true,
        });

        startTimeInput = input.build({
            label: 'Start Time',
            type: 'time',
            value: startTime,
            readonly: formReadOnly,
        });

        endTimeInput = input.build({
            label: 'End Time',
            type: 'time',
            value: endTime,
            readonly: formReadOnly,
        });

        ETADropdown = dropdown.build({
            label: 'Extra Travel Allowance (ETA)',
            dropdownId: "ETADropdown",
            value: ETA,
            readonly: formReadOnly,
        });

        contactMethodDropdown = dropdown.build({
            label: "Contact Method",
            dropdownId: "contactMethodDropdown",
            value: contactType,
            readonly: formReadOnly,
        });


        CNRDropdown = dropdown.build({
            label: 'Critical Need Rate?',
            dropdownId: "CNRDropdown",
            value: CNR,
            readonly: formReadOnly,
        });

        bilingualSupplementDropdown = dropdown.build({
            label: 'Bilingual Supplement ?',
            dropdownId: "bilingualSupplementDropdown",
            value: bilingualSupplement,
            readonly: formReadOnly,
        });

        narrativeOutcomeInput = input.build({
            label: 'Summary of Contact or Service Outcome',
            value: notes,
            type: 'textarea',
            classNames: 'autosize',
            readonly: formReadOnly,
        });

        saveNoteBtn = button.build({
            text: 'Save',
            style: 'secondary',
            type: 'contained',
            icon: 'save',
            classNames: ['caseNoteSave', 'disabled'],
            callback: async () => {
                insertFormData('save');
            },
        });
        saveAndNewNoteBtn = button.build({
            text: 'Save & New',
            style: 'secondary',
            type: 'contained',
            icon: 'add',
            classNames: ['caseNoteSave', 'disabled'],
            callback: async () => {
                insertFormData('saveandNew');
            },
        });
        updateNoteBtn = button.build({
            text: 'update',
            style: 'secondary',
            type: 'contained',
            icon: 'add',
            callback: async () => {
                updateFormData();
            },
        });
        deleteNoteBtn = button.build({
            text: 'Delete',
            style: 'secondary',
            type: 'contained',
            icon: 'delete',
            callback: async () => {
                deleteConfirmation(caseNoteId);
            },
        });
        cancelNoteBtn = button.build({
            text: 'cancel',
            style: 'secondary',
            type: 'outlined',
            icon: 'close',
            classNames: ['caseNoteCancel'],
            callback: async () => {
                OOD.loadOODLanding();
            },
        });

        setupEvents();

        let myconsumer = buildConsumerCard(currentConsumer)

        let container = document.createElement("div");
        container.classList.add("monthlyForm");
        var LineBr = document.createElement('br');

        const heading = document.createElement('h2');
        heading.innerHTML = 'General Services - OOD Form 7';
        heading.classList.add('OODsectionHeading');

        container.appendChild(myconsumer);
        container.appendChild(LineBr);
        container.appendChild(heading);
        container.appendChild(LineBr);

        const inputContainer0 = document.createElement('div');
        inputContainer0.classList.add('ood_form4monthlyplacement_inputContainer1');
        inputContainer0.appendChild(serviceDateInput);
        inputContainer0.appendChild(startTimeInput);
        inputContainer0.appendChild(endTimeInput);

        const inputContainer2 = document.createElement('div');
        inputContainer2.classList.add('ood_form4monthlyplacement_inputContainer1');
        inputContainer2.appendChild(contactMethodDropdown);
        inputContainer2.appendChild(ETADropdown);
        inputContainer2.appendChild(CNRDropdown);
        inputContainer2.appendChild(bilingualSupplementDropdown);

        container.appendChild(inputContainer0);
        container.appendChild(inputContainer2);
        container.appendChild(narrativeOutcomeInput);

        let updatecontainer = document.createElement("div");
        updatecontainer.classList.add("updatecontainer");

        let updatemessage = document.createElement("div");
        updatemessage.classList.add("updatemessage");

        updatemessage.innerHTML = `<span style="color: red">This record was created by another user therefore no edits can be made.</span>`;
        updatecontainer.appendChild(updatemessage);

        let btnWrap = document.createElement("div");
        btnWrap.classList.add("btnWrap");
        (caseNoteId == '0') ? btnWrap.appendChild(saveNoteBtn) : btnWrap.appendChild(updateNoteBtn);
        (caseNoteId == '0') ? btnWrap.appendChild(saveAndNewNoteBtn) : btnWrap.appendChild(deleteNoteBtn);


        let btnWrap2 = document.createElement("div");
        btnWrap2.classList.add("btnWrap");
        btnWrap2.appendChild(cancelNoteBtn);

        let btnRow = document.createElement("div");
        btnRow.classList.add("btnRow");
        btnRow.appendChild(btnWrap);
        btnRow.appendChild(btnWrap2);

        if (userId !== currentEntryUserId) btnRow.appendChild(updatecontainer);

        container.appendChild(btnRow);

        populateStaticDropDowns();
        populateContactTypeDropdown();

        DOM.ACTIONCENTER.appendChild(container);
        DOM.autosizeTextarea();

        checkRequiredFields();
    }

    async function populateContactTypeDropdown() {

        const {
            getContactTypesResult: contactTypes,
        } = await OODAjax.getContactTypesAsync();
        let data = contactTypes.map((contactType) => ({
            id: contactType.contactCode,
            value: contactType.contactCode,
            text: contactType.contactCaption,
        }));

        const index = data.findIndex((x) => x.id == contactType);
        if (index === -1) {
            // case note contactType not in the contactTypes DDL
        }

        data.unshift({ id: null, value: 'SELECT', text: 'SELECT' }); //ADD Blank value         
        dropdown.populate("contactMethodDropdown", data, contactType);
    }

    function populateStaticDropDowns() {
        const ETADropdownData = [
            { text: 'SELECT', value: 'SELECT' },
            { text: '1', value: '1' },
            { text: '2', value: '2' },
            { text: '3', value: '3' },
            { text: '4', value: '4' },
            { text: '5', value: '5' },
        ];
        const yesNoDropdownData = [
            { text: 'SELECT', value: 'SELECT' },
            { text: 'Yes', value: 'Y' },
            { text: 'No', value: 'N' },
        ];

        dropdown.populate(ETADropdown, ETADropdownData, ETA);
        dropdown.populate(CNRDropdown, yesNoDropdownData, CNR);
        dropdown.populate(bilingualSupplementDropdown, yesNoDropdownData, bilingualSupplement);
    }

    function checkRequiredFields() {      

        if (!contactType || contactType === '') {
            contactMethodDropdown.classList.add('error');
        } else {
            contactMethodDropdown.classList.remove('error');
        }

        if (!CNR || CNR === '') {
            CNRDropdown.classList.add('error');
        } else {
            CNRDropdown.classList.remove('error');
        }

        if (!bilingualSupplement || bilingualSupplement === '') {
            bilingualSupplementDropdown.classList.add('error');
        } else {
            bilingualSupplementDropdown.classList.remove('error');
        }

        var noteInput = narrativeOutcomeInput.querySelector('textarea');

        if (noteInput.value === '') {
            narrativeOutcomeInput.classList.add('error');
        } else {
            narrativeOutcomeInput.classList.remove('error');
        }

        checkServiceDateInput();
        checkStartInputTime();
        checkEndInputTime();
        setBtnStatus();
    }

    function checkServiceDateInput() {
        let todaydate = new Date();
        let myservicedate = new Date(serviceDate);

        var isDateBefore = dates.isBefore(myservicedate, todaydate);

        if (!isDateBefore) {
            serviceDateInput.classList.add('error');
        } else {
            serviceDateInput.classList.remove('error');
        }

    }

    function setBtnStatus() {
        var hasErrors = [].slice.call(document.querySelectorAll('.error'));
        if ((hasErrors.length !== 0) || formReadOnly) {
            saveNoteBtn.classList.add('disabled');
            saveAndNewNoteBtn.classList.add('disabled');
            updateNoteBtn.classList.add('disabled');
        } else {
            saveNoteBtn.classList.remove('disabled');
            saveAndNewNoteBtn.classList.remove('disabled');
            updateNoteBtn.classList.remove('disabled');
        }
         
        if ((userId !== currentEntryUserId) || !$.session.OODDelete) {
            deleteNoteBtn.classList.add('disabled');
        } else {
            deleteNoteBtn.classList.remove('disabled')
        }
    }

    function checkEndInputTime() {
        var endInput = endTimeInput.querySelector('input');
        var todaysDate = UTIL.getTodaysDate();
        currentserviceDate = UTIL.formatDateToIso(serviceDate.split(' ')[0]);

        if (currentserviceDate === todaysDate && checkTimeForAfterNow(endInput.value)) {
            endTimeInput.classList.add('error');
            return;
        } else {
            endTimeInput.classList.remove('error');
        }

        var isEndAfterStartTime = validateStartEndTimes('endCheck')

        if (isEndAfterStartTime) {
            endTimeInput.classList.remove('error');

        } else {
            endTimeInput.classList.add('error');
            return;
        }

        var isEndTimeValid = UTIL.validateTime(endInput.value);

        if (isEndTimeValid) {
            endTimeInput.classList.remove('error');

        } else {
            endTimeInput.classList.add('error');
            return;
        }
    }

    function checkStartInputTime() {
        var startInput = startTimeInput.querySelector('input');
        var todaysDate = UTIL.getTodaysDate();
        currentserviceDate = UTIL.formatDateToIso(serviceDate.split(' ')[0]);

        if (currentserviceDate === todaysDate && checkTimeForAfterNow(startInput.value)) {
            startTimeInput.classList.add('error');
            return;
        } else {
            startTimeInput.classList.remove('error');
        }

        var isStartTimeValid = UTIL.validateTime(startInput.value);
        if (isStartTimeValid) {
            startTimeInput.classList.remove('error');
        } else {
            startTimeInput.classList.add('error');
            return;
        }

    }

    function checkTimeForAfterNow(enteredTime) {
        let tempNow = new Date();
        let nowHour = tempNow.getHours() < '10' ? `0${tempNow.getHours()}` : tempNow.getHours();
        let nowMinuet =
            tempNow.getMinutes() < '10' ? `0${tempNow.getMinutes()}` : tempNow.getMinutes();
        return (
            Date.parse(`01/01/2020 ${enteredTime}`) >
            Date.parse(`01/01/2020 ${nowHour}:${nowMinuet}`)
        );
    }

    function validateStartEndTimes(validateTime) {
        var startInput = startTimeInput.querySelector('input');
        var endInput = endTimeInput.querySelector('input');
        var dateInput = serviceDateInput.querySelector('input');
        var startTime = startInput.value;
        var endTime = endInput.value;
        var currentDate = UTIL.getTodaysDate();
        var currentTime = UTIL.getCurrentTime();

        if (validateTime === 'startCheck') {
            if (dateInput.value === currentDate) {
                if (startTime > currentTime) return false; // current date can't have startTime be future time
            }
            if (startTime === '') return false; //error on no time,
            if (startTime !== '' && endTime === '') return true; // initial condition, startTime entered, but not endTime
        } else {
            if (dateInput.value === currentDate) {
                if (endTime > currentTime) return false; // current date can't have endTime be future time
            }

            if (endTime === '' || endTime === '00:00') return false; //error on no time, or a 12am end time
        }

        return startTime >= endTime ? false : true; // startTime can't be after EndTime
    }

    function setupEvents() {
        ETADropdown.addEventListener('change', event => {
            var selectedOption = event.target.options[event.target.selectedIndex];

            if (selectedOption.value == "SELECT") {
                ETA = '';
            } else {
                ETA = selectedOption.value;
            }
            checkRequiredFields();
        });

        contactMethodDropdown.addEventListener('change', event => {
            var selectedOption = event.target.options[event.target.selectedIndex];

            if (selectedOption.value == "SELECT") {
                contactType = '';
            } else {
                contactType = selectedOption.value;
            }
            checkRequiredFields();
        });

        CNRDropdown.addEventListener('change', event => {
            var selectedOption = event.target.options[event.target.selectedIndex];

            if (selectedOption.value == "SELECT") {
                CNR = '';
            } else {
                CNR = selectedOption.value;
            }
            checkRequiredFields();
        });

        bilingualSupplementDropdown.addEventListener('change', event => {
            var selectedOption = event.target.options[event.target.selectedIndex];

            if (selectedOption.value == "SELECT") {
                bilingualSupplement = '';
            } else {
                bilingualSupplement = selectedOption.value;
            }
            checkRequiredFields();
        });

        startTimeInput.addEventListener('focusout', event => {
            startTime = event.target.value;
            checkStartInputTime();
            checkEndInputTime();
            setBtnStatus();
        });

        endTimeInput.addEventListener('change', event => {
            endTime = event.target.value;
            checkStartInputTime();
            checkEndInputTime();
            setBtnStatus();
        });

        serviceDateInput.addEventListener('change', event => {
            serviceDate = event.target.value;
            checkServiceDateInput();
            checkStartInputTime();
            checkEndInputTime();
            setBtnStatus();

        });
        serviceDateInput.addEventListener('keydown', event => {
            event.preventDefault();
            event.stopPropagation();
        });

        narrativeOutcomeInput.addEventListener('input', event => {
            notes = event.target.value;
            checkRequiredFields();
        });

        saveAndNewNoteBtn.addEventListener('click', event => {
            saveAndNewNoteBtn.classList.add('disabled');
            saveNoteBtn.classList.add('disabled');
        });

        saveNoteBtn.addEventListener('click', event => {
            saveAndNewNoteBtn.classList.add('disabled');
            saveNoteBtn.classList.add('disabled');
        });
    }

    // build display of selected consumers with their associated "Entry" buttons
    function buildConsumerCard(consumer) {

        const consumerRow = document.createElement('div');
        var LineBr = document.createElement('br');

        consumer.card.classList.remove('highlighted');

        const wrap = document.createElement('div');
        wrap.classList.add('planConsumerCard');

        wrap.appendChild(consumer.card);

        consumerRow.appendChild(wrap);
        consumerRow.appendChild(LineBr);
        return consumerRow;
    }

    function updateFormData() {
        var data = {
            consumerId,
            caseNoteId,
            serviceDate: UTIL.formatDateToIso(serviceDate.split(' ')[0]),
            startTime,
            endTime,
            ETA,
            contactType,
            bilingualSupplement,
            notes,
            userId,
            CNR,
        };

        OODAjax.updateForm7GeneralServiceEditData(data, function (results) {
            successfulSave.show();
            setTimeout(function () {
                successfulSave.hide();
                OOD.loadOODLanding();
            }, 2000);
        });
    }

    function insertFormData(saveType) {
        var data = {
            consumerId,
            caseNoteId,
            serviceDate: UTIL.formatDateToIso(serviceDate.split(' ')[0]),
            startTime,
            endTime,
            ETA,
            contactType,
            bilingualSupplement, 
            notes,
            caseManagerId,
            userId,
            serviceId,
            referenceNumber,
            CNR,
        };

        OODAjax.insertForm7GeneralServiceEditData(data, function (results) {  
            successfulSave.show();
            if (saveType == 'saveandNew') {
                setTimeout(function () {
                    successfulSave.hide();
                    overlay.show();
                    OOD.buildEntryServicePopUp(consumerId, 'newEntry');
                }, 2000);
            } else {  //save
                setTimeout(function () {
                    successfulSave.hide();
                    OOD.loadOODLanding();
                }, 2000);
            }
        });

    }

    function deleteConfirmation(caseNoteId) {
        var deletepopup = POPUP.build({
            id: 'deleteWarningPopup',
            classNames: 'warning',
        });
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        var yesBtn = button.build({
            text: 'Yes',
            style: 'secondary',
            type: 'contained',
            icon: 'checkmark',
            callback: async function () {
                POPUP.hide(deletepopup);
                let result = await OODAjax.deleteOODFormEntryAsync(caseNoteId);
                if (result.deleteOODFormEntryResult === "1") {
                    OOD.loadOODLanding();
                }
            },
        });
        var noBtn = button.build({
            text: 'No',
            style: 'secondary',
            type: 'contained',
            icon: 'close',
            callback: function () {
                POPUP.hide(deletepopup);
            },
        });
        btnWrap.appendChild(yesBtn);
        btnWrap.appendChild(noBtn);
        var warningMessage = document.createElement('p');
        warningMessage.innerHTML = 'Are you sure you want to delete this record?';
        deletepopup.appendChild(warningMessage);
        deletepopup.appendChild(btnWrap);
        POPUP.show(deletepopup);
    }

    return {
        init,
    };
})();
